import { fetchTrackingAfterConsent } from "../../untils/fetchTrackingAfterConsent";
import { injectExecutableHtml } from "../../untils/injectHtmlScripts";

/** Blade отдаёт boolean; на всякий случай принимаем и строку из окружения/отладки. */
export function isEnforceTrackingConsentActive(): boolean {
    const v = window.__ENFORCE_TRACKING_COOKIE_CONSENT__;
    return v === true || v === "true";
}

let injectInFlight = false;

/**
 * Один запрос на вкладку: после полного согласия или при уже выставленной cookie,
 * если сервер не отдал трекинг в HTML (cookie не дошла до SSR и т.п.).
 */
export async function runTrackingAfterConsentInject(): Promise<void> {
    if (!isEnforceTrackingConsentActive()) {
        return;
    }
    if (document.documentElement.dataset.trackingConsentInjected === "1") {
        return;
    }
    if (window.__SSR_LOADED_CONSENT_TRACKING__ === true) {
        document.documentElement.dataset.trackingConsentInjected = "1";
        return;
    }
    if (injectInFlight) {
        return;
    }
    injectInFlight = true;
    try {
        const payload = await fetchTrackingAfterConsent();
        if (payload?.headHtml) {
            injectExecutableHtml(payload.headHtml, document.head);
        }
        document.documentElement.dataset.trackingConsentInjected = "1";
    } catch (error) {
        injectInFlight = false;
        // eslint-disable-next-line no-console
        console.error("Ошибка загрузки трекинга после согласия:", error);
    }
}
